import React from "react";
import {
  Spinner,
  Intent,
  Button,
  Callout,
  FormGroup,
  InputGroup,
  ControlGroup
} from "@blueprintjs/core";
import { Toolbar } from "../../../molecules/Toolbar";
import SettingsTab from "../SettingsTab";
import SettingsForm from "../SettingsForm";
import FormSection from "../../../atoms/FormSection/FormSection";
import useTaxAddressInfo from "./useTaxAddressInfo";
import styles from "./Taxes.module.scss";
import StateOptions from "../BankAccountSettings/StateOptions";
import FormInfo from "../../../atoms/FormInfo/FormInfo";

function TaxSettings() {
  const {
    street,
    state,
    city,
    zipCode,
    error,
    loading,
    setStreet,
    setState,
    setCity,
    setZipCode,
    addAddress,
    data,
    queryLoading
  } = useTaxAddressInfo();

  if (queryLoading || !data) {
    return (
      <SettingsTab centered>
        <Spinner />
      </SettingsTab>
    );
  }

  return (
    <SettingsTab>
      <Toolbar title="Settings" />

      <SettingsForm>
        {error && (
          <Callout
            icon="error"
            intent={Intent.DANGER}
            title="We couldn't save your Tax settings."
          >
            {error.message}
          </Callout>
        )}
        <FormSection>
          <div className={styles.addressInfo}>
            <FormGroup label="Taxes">
              <FormInfo>
                Video Squirrel calculates tax for your customers at checkout. In
                order for us to do this, please provide your address of Nexus.
              </FormInfo>
            </FormGroup>

            <FormGroup label="Street">
              <InputGroup
                type="text"
                autoCapitalize="none"
                autoCorrect="false"
                value={street || ""}
                placeholder="Street"
                onChange={setStreet}
              />
            </FormGroup>

            <ControlGroup
              fill={true}
              vertical={false}
              className={styles.controlGroup}
            >
              <FormGroup label="City">
                <InputGroup
                  type="text"
                  autoCapitalize="none"
                  autoCorrect="false"
                  value={city || ""}
                  placeholder="City"
                  onChange={setCity}
                />
              </FormGroup>
              <div className={styles.state}>
                <StateOptions state={state || ""} onChange={setState} />
              </div>
              <FormGroup label="Zip Code">
                <InputGroup
                  type="text"
                  autoCapitalize="none"
                  autoCorrect="false"
                  value={zipCode || ""}
                  placeholder="Zip Code"
                  onChange={setZipCode}
                />
              </FormGroup>
            </ControlGroup>
          </div>
          <div className={styles.footer}>
            <Button
              onClick={addAddress}
              intent={Intent.PRIMARY}
              loading={loading}
              disabled={loading}
              text="Save"
              style={{ marginRight: "8px" }}
            />
          </div>
        </FormSection>
      </SettingsForm>
    </SettingsTab>
  );
}

export default TaxSettings;
